"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsApi = exports.deleteToolLink = exports.updateToolLink = exports.addToolLink = exports.fetchToolLinks = exports.clearScript = exports.frameworkVersions = exports.editMembership = exports.deleteMembership = exports.addMembership = exports.getMemberships = exports.fetchLastScriptUpdate = exports.deleteCustomVar = exports.getCustomVar = exports.postCustomVar = exports.getCustomVarAll = exports.deleteQuerystring = exports.getQuerystring = exports.postQuerystring = exports.getQuerystringAll = exports.deleteCrossDomain = exports.getCrossDomain = exports.postCrossDomain = exports.getCrossDomainAll = exports.deleteExcludeIp = exports.getExcludeIp = exports.postExcludeIp = exports.getExcludeIpAll = exports.fetchEnabledDMPs = exports.buildScript = exports.verifySMSCode = exports.sendSMS = void 0;
const qs_1 = __importDefault(require("qs"));
/**
 * -- 👀 THIS IS A LEGACY FILE NO CODE SHOULD BE ADDED HERE. 👀 --
 *
 * It does not respect api-client architecture as it reflects application domains instead of sticking to API ones.
 *
 * This endpoints will be replaced one by one by versioned one until this file disappear.
 */
// USER PROFILE
const sendSMS = (caller) => () => caller(`/api/core/mfa/sms_code_verification?check_mfa_enabled=0`).post();
exports.sendSMS = sendSMS;
const verifySMSCode = (caller) => ({ verification_code }) => caller(`/api/core/mfa/check_verification_code?verification_code=${verification_code}&check_mfa_enabled=0`).get();
exports.verifySMSCode = verifySMSCode;
// Build script
const buildScript = (caller) => ({ accountId, hostType }) => {
    const query = qs_1.default.stringify({ host_type: hostType }, { addQueryPrefix: true });
    return caller(`/backend/accounts/${accountId}/tag-rebuild${query}`).patch();
};
exports.buildScript = buildScript;
// DMPS
const fetchEnabledDMPs = (caller) => ({ accountId, _max_per_page = 0 }) => {
    return caller(`/api/interface/accounts/${accountId}/dmps`).get({ _max_per_page });
};
exports.fetchEnabledDMPs = fetchEnabledDMPs;
// ExcludeIP
const getExcludeIpAll = (caller) => ({ accountId, maxPerPage = 0, page = 1 }) => caller(`/api/core/accounts/${accountId}/exclude_ips`).get({ _max_per_page: maxPerPage, _page: page });
exports.getExcludeIpAll = getExcludeIpAll;
const postExcludeIp = (caller) => ({ accountId, payload }) => caller(`/api/core/accounts/${accountId}/exclude_ips`).post(payload);
exports.postExcludeIp = postExcludeIp;
const getExcludeIp = (caller) => ({ accountId, excludedIpId }) => caller(`/api/core/accounts/${accountId}/exclude_ips/${excludedIpId}`).get();
exports.getExcludeIp = getExcludeIp;
const deleteExcludeIp = (caller) => ({ accountId, excludedIpId }) => caller(`/api/core/accounts/${accountId}/exclude_ips/${excludedIpId}`).delete();
exports.deleteExcludeIp = deleteExcludeIp;
//
// CROSS_DOMAIN
const getCrossDomainAll = (caller) => ({ accountId, maxPerPage = 0, page = 1 }) => caller(`/api/core/accounts/${accountId}/cross_domain_trackings`).get({ _max_per_page: maxPerPage, _page: page });
exports.getCrossDomainAll = getCrossDomainAll;
const postCrossDomain = (caller) => ({ accountId, payload }) => caller(`/api/core/accounts/${accountId}/cross_domain_trackings`).post(payload);
exports.postCrossDomain = postCrossDomain;
const getCrossDomain = (caller) => ({ accountId, crossDomainId }) => caller(`/api/core/accounts/${accountId}/cross_domain_trackings/${crossDomainId}`).get();
exports.getCrossDomain = getCrossDomain;
const deleteCrossDomain = (caller) => ({ accountId, crossDomainId }) => caller(`/api/core/accounts/${accountId}/cross_domain_trackings/${crossDomainId}`).delete();
exports.deleteCrossDomain = deleteCrossDomain;
// QUERYSTRING
const getQuerystringAll = (caller) => ({ accountId, maxPerPage = 0, page = 1 }) => caller(`/api/core/accounts/${accountId}/url_variable`).get({ _max_per_page: maxPerPage, _page: page });
exports.getQuerystringAll = getQuerystringAll;
const postQuerystring = (caller) => ({ accountId, payload }) => caller(`/api/core/accounts/${accountId}/url_variable`).post(payload);
exports.postQuerystring = postQuerystring;
const getQuerystring = (caller) => ({ accountId, querystringId }) => caller(`/api/core/accounts/${accountId}/url_variable/${querystringId}`).get();
exports.getQuerystring = getQuerystring;
const deleteQuerystring = (caller) => ({ accountId, querystringId }) => caller(`/api/core/accounts/${accountId}/url_variable/${querystringId}`).delete();
exports.deleteQuerystring = deleteQuerystring;
// CUSTOM VAR
const getCustomVarAll = (caller) => ({ accountId, maxPerPage = 0, page = 1 }) => caller(`/api/core/accounts/${accountId}/custom_variable`).get({ _max_per_page: maxPerPage, _page: page });
exports.getCustomVarAll = getCustomVarAll;
const postCustomVar = (caller) => ({ accountId, payload }) => caller(`/api/core/accounts/${accountId}/custom_variable`).post(payload);
exports.postCustomVar = postCustomVar;
const getCustomVar = (caller) => ({ accountId, customVarId }) => caller(`/api/core/accounts/${accountId}/custom_variable/${customVarId}`).get();
exports.getCustomVar = getCustomVar;
const deleteCustomVar = (caller) => ({ accountId, customVarId }) => caller(`/api/core/accounts/${accountId}/custom_variable/${customVarId}`).delete();
exports.deleteCustomVar = deleteCustomVar;
// INFO_SCRIPTS
const fetchLastScriptUpdate = (caller) => ({ accountId, hostType }) => caller(`/api/interface/accounts/${accountId}/info_script`).get({ host_type: hostType });
exports.fetchLastScriptUpdate = fetchLastScriptUpdate;
// MEMBERSHIPS
const getMemberships = (caller) => (options) => {
    const { accountId, _page, _max_per_page } = options;
    return caller(`/api/core/accounts/${accountId}/membership`).get({
        _max_per_page,
        _page,
    });
};
exports.getMemberships = getMemberships;
const addMembership = (caller) => ({ id, email, role }) => caller(`/api/core/accounts/${id}/membership`).post({ email, role });
exports.addMembership = addMembership;
const deleteMembership = (caller) => (params = {}) => caller(`/api/core/accounts/${params.accountId}/membership/${params.userId}`).delete();
exports.deleteMembership = deleteMembership;
const editMembership = (caller) => ({ accountId, userId, role }) => caller(`api/core/accounts/${accountId}/membership/${userId}`).patch({ role });
exports.editMembership = editMembership;
// FRAMEWORK_VERSIONS
const frameworkVersions = (caller) => (params = { maxPerPage: 0 }) => {
    return caller(`/api/core/framework_versions`).get({
        _max_per_page: params.maxPerPage,
    });
};
exports.frameworkVersions = frameworkVersions;
// CLEAR_SCRIPT
const clearScript = (caller) => ({ accountId }) => caller(`/backend/accounts/${accountId}/tag-clear`).patch();
exports.clearScript = clearScript;
// TOOLLINKS
const fetchToolLinks = (caller) => ({ accountId, queryParams }) => caller(`/api/core/accounts/${accountId}/toollinks`).get(queryParams);
exports.fetchToolLinks = fetchToolLinks;
const addToolLink = (caller) => ({ accountId, payload }) => caller(`/api/core/accounts/${accountId}/toollinks`).post(payload);
exports.addToolLink = addToolLink;
const updateToolLink = (caller) => ({ accountId, toolLinkId, payload }) => caller(`/api/core/accounts/${accountId}/toollinks/${toolLinkId}`).patch(payload);
exports.updateToolLink = updateToolLink;
const deleteToolLink = (caller) => ({ accountId, toolLinkId }) => caller(`/api/core/accounts/${accountId}/toollinks/${toolLinkId}`).delete();
exports.deleteToolLink = deleteToolLink;
const settingsApi = (caller) => ({
    // BUILD_SCRIPT
    buildScript: (0, exports.buildScript)(caller),
    // DMPS
    fetchEnabledDMPs: (0, exports.fetchEnabledDMPs)(caller),
    // EXCLUDE_IP
    getExcludeIpAll: (0, exports.getExcludeIpAll)(caller),
    postExcludeIp: (0, exports.postExcludeIp)(caller),
    getExcludeIp: (0, exports.getExcludeIp)(caller),
    deleteExcludeIp: (0, exports.deleteExcludeIp)(caller),
    // CROSS_DOMAIN
    getCrossDomainAll: (0, exports.getCrossDomainAll)(caller),
    postCrossDomain: (0, exports.postCrossDomain)(caller),
    getCrossDomain: (0, exports.getCrossDomain)(caller),
    deleteCrossDomain: (0, exports.deleteCrossDomain)(caller),
    // QUERYSTRING
    getQuerystringAll: (0, exports.getQuerystringAll)(caller),
    postQuerystring: (0, exports.postQuerystring)(caller),
    getQuerystring: (0, exports.getQuerystring)(caller),
    deleteQuerystring: (0, exports.deleteQuerystring)(caller),
    // CROSS VAR
    getCustomVarAll: (0, exports.getCustomVarAll)(caller),
    postCustomVar: (0, exports.postCustomVar)(caller),
    getCustomVar: (0, exports.getCustomVar)(caller),
    deleteCustomVar: (0, exports.deleteCustomVar)(caller),
    // INFO_SCRIPTS
    fetchLastScriptUpdate: (0, exports.fetchLastScriptUpdate)(caller),
    // PROFILE
    sendSMS: (0, exports.sendSMS)(caller),
    verifySMSCode: (0, exports.verifySMSCode)(caller),
    // FRAMEWORK_VERSIONS
    frameworkVersions: (0, exports.frameworkVersions)(caller),
    // CLEAR_SCRIPT
    clearScript: (0, exports.clearScript)(caller),
    // MEMBERSHIPS
    getMemberships: (0, exports.getMemberships)(caller),
    addMembership: (0, exports.addMembership)(caller),
    deleteMembership: (0, exports.deleteMembership)(caller),
    editMembership: (0, exports.editMembership)(caller),
    // TOOLLINKS
    fetchToolLinks: (0, exports.fetchToolLinks)(caller),
    addToolLink: (0, exports.addToolLink)(caller),
    updateToolLink: (0, exports.updateToolLink)(caller),
    deleteToolLink: (0, exports.deleteToolLink)(caller),
});
exports.settingsApi = settingsApi;
//# sourceMappingURL=api.js.map